import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Styles from './Tabs.scss';

export const Tabs = ({ children, className }) => (
  <div className={cn(Styles.tabs, className)}>
    {children}
  </div>
);
Tabs.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
};

export const Tab = ({ name, onClick, isActive, className }) => {
  const classNames = cn(Styles.tab, className, {
    [Styles.active]: isActive
  });
  return (
    <div onClick={onClick} className={classNames}>
      <span className={Styles.tabContent}>{name}</span>
    </div>
  );
};
Tabs.propTypes = {
  name: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
  isActive: PropTypes.bool,
};
